<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <SubmenuDropdown
    :close-on-click="true"
    round
    right
    data-testid="account-dropdown-submenu"
    @mouseenter="$emit('tracking-event', {
      action: 'navDropdownHover',
      args: { label: 'Account' },
    })"
  >
    <div class="d-flex">
      <DpplSvg file-name="icon-settings" />
    </div>

    <NavigationMenu
      :columns="nonEmptySections.length > 2 ? 2 : 1"
      :link-sections="settingsNavLinks"
      @tracking-event="(params) => $emit('tracking-event', params)"
    />
  </SubmenuDropdown>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import NavigationMenu from '@/components/shared/NavigationMenu.vue';
import SubmenuDropdown from '@/components/editor/SubmenuDropdown.vue';

export default {
  name: 'AccountDropdown',
  components: {
    DpplSvg,
    NavigationMenu,
    SubmenuDropdown,
  },
  props: {
    settingsNavLinks: { type: Array, default: () => [] },
  },
  emits: ['tracking-event'],
  computed: {
    nonEmptySections() {
      return this.settingsNavLinks
        .filter((section) => section.links
          .find((link) => link.show));
    },
  },
};
</script>
